import { isSameIban } from "@oefr/utils/formatter/iban"

/**
 * Checks whether the given IBAN matches the Octopus BNP IBAN.
 */
export function isOctopusIban(iban: string): boolean {
    const octopusIban = process.env.NEXT_PUBLIC_OCTOPUS_BNP_IBAN
    if (!octopusIban) return false

    return isSameIban(iban, octopusIban)
}
